"use client";

import * as React from "react";
import { EditorContent } from "@tiptap/react";
import { Content } from "@tiptap/core";
import { cn } from "@/lib/utils";
import {
  useMinimalTiptapEditor,
  UseMinimalTiptapEditorProps,
} from "./hooks/use-minimal-tiptap";

export interface MinimalTiptapProps
  extends Omit<UseMinimalTiptapEditorProps, "onUpdate" | "onBlur"> {
  value?: Content;
  onValueChange?: (value: Content) => void;
  className?: string;
  editorContentClassName?: string;
}

export const MinimalTiptapEditor = React.forwardRef<
  HTMLDivElement,
  MinimalTiptapProps
>(({ value, className, editorContentClassName, ...props }, ref) => {
  const editor = useMinimalTiptapEditor({
    value,
    editable: false,
    ...props,
  });

  if (!editor) {
    return null;
  }

  return (
    <div
      ref={ref}
      className={cn("flex w-full flex-col focus-within:input", className)}
    >
      <EditorContent
        editor={editor}
        className={cn("minimal-tiptap-editor ", editorContentClassName)}
      />
    </div>
  );
});

MinimalTiptapEditor.displayName = "MinimalTiptapEditor";

export default MinimalTiptapEditor;
